import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import UserSettingsLayout from 'components/user-settings/UserSettingsLayout';
import NotificationSettings from 'components/user-settings/NotificationSettings';
import { UserSettingsRouteV2Id } from 'routes/routesConfigV2';
import NotificationSettingsPageStore, {
  NotificationSettingsPageStoreContext,
  useNotificationSettingsPageStore,
} from 'store/pages/user-settings/notification-settings/pageStore';
import { Button, HEADER_SPACING_PRESETS } from '@insurancemenu/imenu-components-lib';
import { FooterStyled } from './styles';

const PageContent: React.FC = observer(() => {
  const { isInitialDataLoading, isActionLoading, canComplete, getInitialData, saveSelectedEmails } =
    useNotificationSettingsPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <UserSettingsLayout
      pageId={UserSettingsRouteV2Id.NOTIFICATION_SETTINGS}
      isInitialLoading={isInitialDataLoading}
      isActionLoading={isActionLoading}
      pageHeader={{
        spacing: HEADER_SPACING_PRESETS.withActionBelow,
      }}
      pageFooter={
        <FooterStyled>
          <Button color="primary" size="large" disabled={!canComplete} onClick={saveSelectedEmails}>
            Update
          </Button>
        </FooterStyled>
      }
    >
      <NotificationSettings />
    </UserSettingsLayout>
  );
});

const NotificationSettingsPage: React.FC = () => {
  const pageStore = useMemo(() => new NotificationSettingsPageStore(), []);

  return (
    <NotificationSettingsPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </NotificationSettingsPageStoreContext.Provider>
  );
};

export default NotificationSettingsPage;
